<template>
  <div class="container-school">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <div>
      <mt-navbar v-model="selected">
        <mt-tab-item id="1">学校简介</mt-tab-item>
        <mt-tab-item id="2">学校历史</mt-tab-item>
        <mt-tab-item id="3">校长致辞</mt-tab-item>
        <mt-tab-item id="4">学校荣誉</mt-tab-item>
        <!--<mt-tab-item id="5">更名声明</mt-tab-item>-->
      </mt-navbar>
    </div>
    <p class="fenge"></p>
    <div class="menu">
      <!-- tab-container -->
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
          <div class="right-wapper">
            <div class="school-text">布雷斯特高等商学院（Brest Business
              School，以下简称BBS）成立于1962年，是一所受中法两国政府认可的高等教育学校。主校区位于法国布雷斯特和巴黎拉德芳斯，学校拥有本科，硕士和博士三种文凭层次的培养项目。
            </div>
            <div class="his-wrapper">
              <img src="../assets/images/school/school01.png">
            </div>
            <div class="school-text">BBS
              不断寻求国际化的合作和发展，在全球拥有50多所合作院校，所提供的15个双学位文凭遍布美国、德国、英国、爱尔兰、芬兰等9个国家。国内主要合作院校包括：上海理工大学、北京外国语大学、中国海洋大学等。BBS同时也是多个国际组织的成员，如：欧盟伊拉斯谟计划
              (Erasmus Scheme)、欧洲国际教育协会(European Association for International Education)等，并于2021年7月获得国际商学院促进协会（AACSB
              International）的认证。
            </div>
            <div class="his-wrapper">
              <img src="../assets/images/school/school02.png">
            </div>
            <div class="school-text">
              法国前100家企业中，三分之二的管理者均毕业于精英大学联盟的成员院校，BBS于1962年推出精英大学硕士课程，并于1992年加入精英大学联盟。秉承法国独特的“精英教育模式”，强调严格选拔，优质教学，注重实践。BBS课程完全按照企业需求构建，学习期间聘请企业专家授课。学生在获得实践经验的同时也得到了未来雇主的青睐。BBS是最早实行“学徒制”教学模式的精英大学之一，学校在校企关系和学徒制这方面经常位居法国商学院的前三位。
            </div>
            <div class="his-wrapper">
              <img src="../assets/images/school/school03.png">
            </div>
            <div class="school-text">
              由于学校对布列塔尼当地经济的贡献，布雷斯特高等商学院在青年领袖中心（CJD），企业领袖俱乐部（DCF），财务管理总监（DFCG）和国家人力资源总协会（ANDRH），布列塔尼产品协会（由300家企业构成）等组织有着重要的领导力和影响力，也有着良好的平台、渠道和共享资源。BBS于2016年创建企业孵化器，为所有学生以及外部项目负责人提供专业知识和行政支持，孵化器也为学生创造了一个预孵化空间，有利于学生创新实践能力的培养。
            </div>
            <div class="his-wrapper">
              <img src="../assets/images/school/school04.png">
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="3">
          <div class="right-wapper">
            <div class="wrapper-item">
              <div class="xiaozhang-wrapper">
                <img src="../assets/images/xiaozhang.png" class="xiaozhang-img"/>
              </div>
              <div class="jianjie">
                <p class="name">沈岱</p>
                <p class="c1">布雷斯特高等商学院校长</p>
                <p>前法国里昂商学院副校长</p>
                <p>国际大学创新联盟创始副理事长</p>
              </div>
            </div>
            <div class="school-text">亲爱的同学们，大家好！</div>
            <div class="school-text">新学期伊始，作为布雷斯特高等商学院的校长，我很荣幸地欢迎 大家来到布雷斯特高等商学院开始一段崭新的学习旅程。</div>
            <div class="school-text">
              众所周知，法国拥有众多世界级的企业和商学院，而我们布 雷斯特商学院也很荣幸的位列其中。 布雷斯特拥有很多企业和学 校，是一个法国少有的同时拥有强大经济实力和丰富高等教育资 源的海滨城市。学校同时提供本科
              、硕士、博士和精英院校项目 等阶段教育。布雷斯特高等商学院所颁发的文凭不但受到中、法两国 教育部的共同认可，并且也被多个国际教育组织所认可。 这一点， 为学生将来继续学业和良好的职业发展提供了有力保障。
            </div>
            <div class="school-text">
              布雷斯特高等商学院与欧洲和国际很多机构都有着长期合作的 传统。我校也是许多国际 协会或合作项目的成员，国际商学院促进协会（AACSB）、欧盟伊拉斯谟 计划（Erasmus
              Scheme）拉丁美洲管理学院理事会（CLADEA）、欧洲国际教育协会（EAIE）、国际大学创 新联盟（IUIA）等。 同时，我们向学生提供了很多世界知名的企业实习机会，使得我们的毕业就业率
              和平均薪资水平始终处于一个较高的水平。
            </div>
            <div class="school-text">在最近几次法国百家商学院的排名中，我们学校始终位于前 列。向全世界开放是我校的核心价值之一，因此我们非常骄傲地欢迎来自世界各地的学生来布雷斯特商 学院学习。
            </div>
            <div class="school-text">最后，再次欢迎各位新同学，让我们携手共建美丽的布雷斯特高等商学院！祝您在学习中取得圆满成功，并期待与您在布雷斯特高等商学院相遇。</div>
            <div class="school-text">欢迎来到布雷斯特高等商学院！ 欢迎加入！</div>
            <div class="school-text" style="text-align: right;">-- Shen Dai 校长</div>
            <div class="video">
              <video controls style="width:100%;" poster="../assets/images/video-poster03.png">
                <source type="video/mp4"
                        src="http://media.hainayx.com/group1/M00/00/20/wKgCEl2BwISAHpvqDFjWNC9WHrk569.mp4"/>
              </video>
            </div>
          </div>
          <p class="right-title">我们的教育目标</p>
          <div class="right-wapper">
            <div class="school-tip">
              布雷斯特高等商学院设计并提供相关的、有效的学术学位课程，帮助学生成为全球化环境下的，负责任的管理者与企业家。同时以应用研究活动为辅助，为区域利益相关者创造经济和社会价值。
            </div>
            <div class="school-tip">我们通过以下方式实现教育目标：</div>
            <div class="school-tip">1. 为学生提供高质量教育内容，帮助学生在迎接全球化挑战和创造社会价值方面做好充足准备</div>
            <div class="school-tip">2. 促进学生，公司和机构的知识和管理实践的改善。</div>
            <div class="school-tip">3. 培养和扶持可转换为创业项目的数字教育和教学的创新实践。</div>
            <div class="school-tip">4. 培养学生的开放性思维</div>
            <div class="school-tip">5. 为地区的机构、公司发展定制人才</div>
            <div class="school-tip">6. 提供多元文化的人力资源服务</div>
            <div class="school-tip">7. 提供国内和国际交流服务</div>
            <div class="school-tip">8. 开展特殊的研究和咨询服务</div>
            <div class="school-tip">9. 大力促进和支持学生创业</div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="2">
          <div class="right-wapper">
            <div class="school-text">布雷斯特高等商学院（Brest Business School，简称BBS），创办于1962年。学校共开设3个校区，
              分别位于布雷斯特（Brest）、瓦纳（Vannes）和巴黎（Paris）。BBS在法国高等教育商学院排名第 35位，全球高校网（4ICU）国家高校排名第193位。
            </div>
            <div class="school-text">布雷斯特高等商学院的“国际商务管理本科”在法国排名第一，“精英高校管理学硕士”在法国60所 商学院排名中位列前三。布雷斯特高等商学院同时也是多个国际组织的成员:
              欧盟伊拉斯谟计划（Erasmus Scheme）、国际商学院促进协会（AACSB International）、欧洲国际教育协会（EAIE）、欧洲管
              理发展基金会（EFMD）、拉丁美洲管理学院理事会（CLADEA）、国际大学创新联盟（IUIA）和国际 互联网教育研究院（IERA）等。
            </div>
            <div class="his-wrapper">
              <img src="../assets/images/histroy.png"/>
            </div>
            <div class="school-tip">• 1962年由法国布列塔尼工商业协会发起成立，当年推出精英大学硕士课程</div>
            <div class="school-tip">• 1992年设立物流管理硕士专业，并加入精英大学联盟</div>
            <div class="school-tip">• 1996年推出企业学徒课程</div>
            <div class="school-tip">• 2000年开设本科及EMBA学位</div>
            <div class="school-tip">• 2002年开设管理控制和金融工程硕士</div>
            <div class="school-tip">• 2006年成立布列塔尼省（Bretagne）企业孵化器</div>
            <div class="school-tip">• 2008年开设瓦纳（VANNES）分校</div>
            <div class="school-tip">• 2012年成为法兰西商学院（FBS）创始成员</div>
            <div class="school-tip">• 2014年更名为布雷斯特高等商学院（Brest Business School）</div>
            <div class="school-tip">• 2016年加入伟东云教育集团</div>
            <div class="school-tip">• 2018年开办面向全球招生的互联网商学院－海纳易学</div>
            <div class="school-tip">• 2021年7月获得国际商学院促进协会（AACSB International）的认证</div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="4">
          <div class="right-wapper">
            <div class="school-text"><span class="t1">• </span>BBS在2012年11月获得中国国家外国专家局颁发的"国际人才交流服务境外机构资格证书"，是获得此资格的第一所法国商学院。
            </div>
            <div class="school-text"><span class="t1">• </span>BBS在2013年的部分专业排名中表现优异：Bachelor in International Management（国际商务本科）被"Le Figaro Etudiant"（《费加罗报》教育专版）评为 法国排名前列。
            </div>
            <div class="school-text"><span class="t1">• </span>Programme Grande Ecole（精英高校管理学硕士）在"Challenges"（《挑战者》商务杂志）法国60所商学院排名中在学生就业，学生多元化等各项都位居前列。
            </div>
            <div class="school-text"><span class="t1">• </span>2021年7月获得国际商学院促进协会（AACSB International）的认证</div>
            <div class="school-text"><span class="t1">• </span>布雷斯特高等商学院获得法国欢迎你 三星认证。</div>
            <div class="school-text"><span class="t1">• </span>布雷斯特高等商学院获得伊拉斯谟计划成员。</div>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "schoolProfile",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      selected: "1"
    };
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
/* banner */

.banner-info {
  width: 100%;
  height: 200px;
  background: url("../assets/images/banner002.png");
  background-size: 100% 100%;
}

/* tab切换样式 */

.mint-navbar {
  width: 95%;
  margin: 0 auto;
  height: 90px;
  line-height: 90px;
  overflow-x: auto;
  white-space: nowrap;
}

.mint-navbar ::-webkit-scrollbar {
  display: none;
}

.mint-navbar .mint-tab-item {
  /*min-width: 170px;*/
  height: 90px;
  color: #333;
  padding: 0;
  margin-right: 20px;
}

.mint-navbar .mint-tab-item.is-selected {
  font-size: 29px;
  color: #e58111;
  border-bottom: none;
}

>>> .mint-tab-item-label {
  font-size: 29px;
  height: 90px;
  line-height: 90px;
}

/*分割线*/

.fenge {
  width: 100%;
  height: 12px;
  background: #f2f2f2;
}

/* 内容展示 */

.menu {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 50px;
  background: #fff;
}

.mint-tab-container-item {
  height: auto;
  width: 95%;
  margin: 0 auto;
}

.right-wapper {
  width: 100%;
  margin: 0 auto;
  margin-top: 38px;
  height: auto;
}

.wrapper-item {
  zoom: 1;
  overflow: hidden;
  margin-bottom: 30px;
}

.xiaozhang-wrapper {
  width: 292px;
  height: 390px;
  display: inline-block;
  float: left;
}

.xiaozhang-img {
  width: 292px;
  height: 100%;
}

.jianjie {
  width: 50%;
  float: right;
  height: 390px;
}

.jianjie p {
  color: #333;
  font-size: 27px;
  line-height: 44px;
}

.name {
  margin-top: 90px;
  font-size: 32px !important;
}

.c1 {
  margin-top: 40px;
}

/* 文字样式 */

.school-text {
  font-size: 29px;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  text-indent: 50px;
  margin-top: 5px;
}

.right-title {
  font-size: 30px;
  color: #333;
  font-weight: bold;
}

.school-tip {
  font-size: 29px;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  margin-top: 5px;
}

.school-text a {
  color: #E58111;
}

.t2 {
  text-align: right;
  margin-top: 30px;
}

/* 视频样式 */

.video {
  width: 100%;
  height: 394px;
  margin-top: 65px;
  margin-bottom: 54px;
}

/* 历届校友 */

.shcoolStudent {
  width: 100%;
  height: auto;
}

.stu-item {
  float: left;
  width: 313px;
  margin-right: 82.5px;
}

.stu-item:nth-child(2n) {
  margin-right: 0px;
}

.stu-item img {
  width: 313px;
  height: auto;
}

.stu-text {
  width: 313px;
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-top: 11px;
  margin-bottom: 28px;
}

/* 图片 */

.his-wrapper {
  text-align: center;
  width: 100%;
  height: auto;
  margin: 33px 0 33px 0;
}

.his-wrapper img {
  width: 100%;
}

/*更改声明*/
.apply-wapper {
  width: 100%;
}

.change-apply {
  width: 100%;
  margin: 0 auto;
}

.change-apply img {
  margin-top: 30px;
  width: 100%;
}

.apply-text {
  width: 100%;
  margin: 0 auto;
  font-size: 29px;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  line-height: 38px;
  margin-top: 30px;
  padding-bottom: 12px;
}

.apply-wrrapper {
  width: 100%;
}

.apply-content {
  width: 100%;
  margin: 0 auto;
  height: 136px;
  margin-top: 30px;
}

.apply-content img {
  width: 100%;
}

.apply-wrrapper img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/schoolProfile.vue